/**
 * Pattern mask for CLABE numbers (Mexican bank account numbers).
 * See pattern details here: https://imask.js.org/guide.html#masked-pattern.
 */ const clabe = '000 000 00000000000 0';

export { clabe };
//# sourceMappingURL=clabe.es.js.map
